import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { resetRuleCreator, createRule, createAllocationRule, updateAllocationRule, updateRule } from 'redux/rules/RulesActions';
import RuleEditorContainer from './RuleEditorContainer';

const mapStateToProps = ({ rules }) => {
  const rule = {
    ...rules.rule,
    ifValue: rules.rule.customRuleAudit ? rules.rule.customRuleAudit.ifUserInput : '',
    thenValue: rules.rule.customRuleAudit ? rules.rule.customRuleAudit.thenUserInput ? rules.rule.customRuleAudit.thenUserInput : ''  : ''
  };

  delete rule.customRuleAudit;

  return ({
    creatingRule: rules.creatingRule,
    pageState: rules.pageState,
    fetchingRule: rules.fetchingRule,
    rule
  });
};

const mapDispatchToProps = dispatch => ({
  rulesActions: bindActionCreators({ resetRuleCreator, createRule, createAllocationRule, updateAllocationRule, updateRule }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(RuleEditorContainer);



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditorContainer/RuleEditorConnector.js